/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Blog_MetaInputs */

const en_directory_home_blog_meta = /** @type {(inputs: Directory_Home_Blog_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editorial guide · 5 min read`)
};

const zh_directory_home_blog_meta = /** @type {(inputs: Directory_Home_Blog_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑精选 · 5 分钟阅读`)
};

/**
* | output |
* | --- |
* | "Editorial guide · 5 min read" |
*
* @param {Directory_Home_Blog_MetaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_blog_meta = /** @type {((inputs?: Directory_Home_Blog_MetaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Blog_MetaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_blog_meta(inputs)
	return zh_directory_home_blog_meta(inputs)
});
export { directory_home_blog_meta as "directory.home.blog_meta" }